import React from 'react';
import { motion } from 'framer-motion';
import { Download, ShieldCheck, CreditCard, Landmark, CheckCircle2 } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-20 pb-16 md:pt-28 md:pb-24 overflow-hidden" data-id="element-120">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-121" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-122">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-123">
          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 text-white" data-id="element-124">
            Todos tus amparos de salud,{' '}
            <span className="text-gold-500" data-id="element-125">resueltos.</span>
          </motion.h1>

          {/* Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="w-full max-w-2xl my-6 md:my-8" data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/tViF6Bt9si274PYX2rpbLi/c7929282-51b5-4e43-8684-f530f006bc0d.png" alt="Tratado práctico Amparo de Salud: tomo principal rodeado de modelos de escritos, jurisprudencia destacada y bonos profesionales" className="w-full h-auto drop-shadow-2xl" data-id="element-127" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col items-center" data-id="element-128">
            <p className="text-lg md:text-xl text-slate-300 font-medium mb-4" data-id="element-129">
              Modelos · Fundamentos · Jurisprudencia · Estrategias listas para
              aplicar
            </p>

            <p className="text-base md:text-lg text-slate-400 mb-8 max-w-2xl" data-id="element-130">
              La herramienta profesional definitiva para abogados. Ahorrá horas
              de trabajo, actuá con mayor seguridad y resolvé consultas contra
              obras sociales y prepagas sin improvisar.
            </p>

            {/* Pills */}
            <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-131">
              <div className="flex items-center gap-2 bg-legal-800 border border-legal-700 rounded-full px-4 py-2 text-sm text-slate-300" data-id="element-132">
                <Download className="w-4 h-4 text-gold-500" data-id="element-133" />
                Material 100% digital
              </div>
              <div className="flex items-center gap-2 bg-legal-800 border border-legal-700 rounded-full px-4 py-2 text-sm text-slate-300" data-id="element-134">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-135" />
                Acceso inmediato
              </div>
              <div className="flex items-center gap-2 bg-legal-800 border border-legal-700 rounded-full px-4 py-2 text-sm text-slate-300" data-id="element-136">
                <CheckCircle2 className="w-4 h-4 text-gold-500" data-id="element-137" />
                Para todos los niveles
              </div>
            </div>

            {/* CTA */}
            <motion.a href="#oferta" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gold-500 hover:bg-gold-400 text-legal-900 font-bold rounded-lg text-lg transition-colors shadow-[0_0_20px_rgba(201,162,74,0.3)]" data-id="element-138">
              QUIERO MI TRATADO AHORA
            </motion.a>

            {/* Trust Badges */}
            <div className="mt-8 flex flex-wrap justify-center items-center gap-4 sm:gap-6 text-sm text-slate-400" data-id="element-139">
              <div className="flex items-center gap-1.5" data-id="element-140">
                <ShieldCheck className="w-4 h-4" data-id="element-141" />
                Garantía 7 días
              </div>
              <div className="flex items-center gap-1.5" data-id="element-142">
                <ShieldCheck className="w-4 h-4" data-id="element-143" />
                Pago 100% seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-144">
                <CreditCard className="w-4 h-4" data-id="element-145" />
                Mercado Pago | Tarjeta
              </div>
              <div className="flex items-center gap-1.5" data-id="element-146">
                <Landmark className="w-4 h-4" data-id="element-147" />
                Transferencia
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};